const LS_PREFIX = "longfans-h5.weworkHomePopup.dismiss.";

/** 本地记录的 dismiss 版本是否仍对当前服务端版本生效 */
export function isWeworkHomePopupDismissed(spaceId: string, serverVersion: number): boolean {
  if (typeof localStorage === "undefined") {
    return false;
  }
  const raw = localStorage.getItem(`${LS_PREFIX}${spaceId}`);
  if (!raw) {
    return false;
  }
  // 旧版仅存 "1"，对新版本不再生效
  if (raw === "1") {
    return serverVersion <= 0;
  }
  const dismissedVersion = Number(raw);
  if (!Number.isFinite(dismissedVersion)) {
    return false;
  }
  return dismissedVersion >= serverVersion;
}

/** 用户点「下次不再提示」时，记录当前弹框配置版本 */
export function markWeworkHomePopupDismissed(spaceId: string, version: number): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.setItem(`${LS_PREFIX}${spaceId}`, String(version));
}
